export default function TextInput({type, identifier, mandatory, value, onChange, disabled }) {
    return (
        <input
            type={type}
            name={identifier}
            id={identifier}
            className={`text-input default-input ${mandatory ? "mandatory-input" : ""}`}
            value={value}
            onChange={onChange}
            required={mandatory}
            disabled={disabled}
        ></input>
    );
}